import { gql } from '@apollo/client';

const SEND_AGENT_EMAIL = gql`
  mutation sendAgentEmail(
    $isTest: Boolean
    $notificationType: NotificationType!
    $overrideSubject: String
    $replyToEmail: String
    $toEmail: String!
    $fromEmail: String
    $userId: String!
    $htmlBody: String!
    $bcc: String
    $templateType: String!
  ) {
    sendAgentEmail(
      isTest: $isTest
      notificationType: $notificationType
      overrideSubject: $overrideSubject
      replyToEmail: $replyToEmail
      toEmail: $toEmail
      fromEmail: $fromEmail
      userId: $userId
      htmlBody: $htmlBody
      bcc: $bcc
      templateType: $templateType
    ) {
      success
    }
  }
`;

export default SEND_AGENT_EMAIL;
